import Super from './-resources';

export default Super.extend({
  queryParams: {
    itemStatus: { refreshModel: true },
  },

  thisType: 'invoice',
});
